import { Component } from '@angular/core';
import { Ndg } from 'src/app/model/ndg';
import { AuthService } from 'src/app/service/auth.service';
import { NdgService } from 'src/app/service/ndg.service';

@Component({
  templateUrl: './show-anag.component.html',
  styleUrls: ['./show-anag.component.scss']
})
export class ShowAnagComponent {
  constructor(
    private ndgService: NdgService,
    private authService: AuthService
  ) {}
  
  get ndg(): Ndg | undefined {
    return this.ndgService.activeNdg;
  }

  hasInsertPermission(): boolean {
    return this.authService.hasAuthority('USER_INSERT');
  }
}
